import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "lang-list" }
const _hoisted_3 = { class: "list-scrollable" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lang = _resolveComponent("Lang")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lang-selector", { active: _ctx.active }])
  }, [
    _createElementVNode("div", {
      class: "lang-btn lang-select-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.trigger && _ctx.trigger(...args)))
    }, [
      _createVNode(_component_Lang, {
        lang: _ctx.locale,
        class: "lang-wrap",
        full: _ctx.full
      }, null, 8, ["lang", "full"]),
      _createElementVNode("img", {
        src: require('../../assets/icons/caret.svg'),
        class: "lang-caret"
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langCodes, (code) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (_ctx.locale !== code)
              ? (_openBlock(), _createElementBlock("div", {
                  key: code,
                  class: _normalizeClass(["lang-item lang-en-btn", [`lang-${code}-btn`]]),
                  onClick: ($event: any) => (_ctx.select(code))
                }, [
                  _createVNode(_component_Lang, {
                    lang: code,
                    class: "lang-wrap",
                    full: _ctx.full
                  }, null, 8, ["lang", "full"])
                ], 10, _hoisted_4))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ])
  ], 2)), [
    [_directive_click_outside, _ctx.close]
  ])
}